import type {
  ProductCategory,
  Variation,
} from 'src/modules/designStudio/helpers/productSelection/types';

export const extractTrackingDataFromVariation = (
  selectedVariation: Variation,
  category: ProductCategory,
) => ({
  variation_uuid: selectedVariation.uuid,
  brandId: selectedVariation.product.provider.uuid,
  product_uuid: selectedVariation.product.uuid,
  productId: selectedVariation.product.id,
  provider_id: selectedVariation.product.provider.uuid,
  product_type: selectedVariation.product.type,
  product_size: selectedVariation.facets.sizing,
  product_color: selectedVariation.name,
  variation_color: selectedVariation.color?.name,
  product_category: category,
  materialId: selectedVariation.id,
  materialColorHex: selectedVariation.color?.hex,
  materialTextureId: selectedVariation.textureId,
});
